// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../comm/store/store'
import VueBus from 'vue-bus'
import 'es6-promise/auto'
import 'babel-polyfill'
import '../../static/common/reset.css'
//引入nprogress
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //这个样式必须引入
import api from '../comm/api/'
import promise from 'es6-promise'; //axios兼容IE
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ECharts from 'vue-echarts/components/ECharts.vue'

import * as filters from '../comm/filters' // 全局filter
// 手动引入 ECharts 各模块来减小打包体积
import echarts from 'echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import VueQriously from 'vue-qriously'
// 简单配置
//NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false });

Vue.use(VueQriously);

router.beforeEach((to,from,next) => {
  document.title = '工程施工实时监控系统 - 江苏东交智控科技集团股份有限公司'
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
});

Vue.use(VueBus);

Vue.config.productionTip = false;

Vue.prototype.$api = api;


promise.polyfill();


Vue.use(VueCookies);

Vue.use(ElementUI);

Vue.prototype.$echarts = echarts;


Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

// 注册组件后即可使用
Vue.component('chart', ECharts);

Vue.use(VueVideoPlayer);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  echarts,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/eastTrans/main.js